export function isInteger(input?: unknown) {
	if (!input && input !== 0) {
		return false;
	}
	return Number.isInteger(Number(input));
}
